// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { navigationDrawerStyles } from "@rpsc/Overrides/Components/NavigationDrawer";
import RightNav from "@rpsc/XDL/Icons/IconAngleRight";
import IconLogout from "@rpsc/XDL/Icons/IconLogout";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import {
    color,
    createLinkIconStyles,
    selectedPanelItem,
    sharedPanelMenuStyles,
    styledScrollbar,
    xScreen,
} from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

navigationDrawerStyles.menuTriggerButton = {
    size: 30,
    variant: "secondary",
    css: css`
        &,
        &:hover,
        &:focus {
            padding: 6px;
            border: none;
            background-color: transparent !important;
            &&& ${IconWrapper}, &&& svg {
                color: ${color("text.link")};
                width: 14px;
                height: 14px;
            }
        }
    `,
};

navigationDrawerStyles.drawer = {
    mergeCss: true,
    cssOverrides: {
        drawerBody: css`
            transform: translate(-100%, 0);
            border: none;
            padding: 10px 0;
            background-color: ${color("common.white")};
            overflow: hidden;
            width: 360px;
            ${xScreen("lte", "sm")} {
                width: 100%;
            }
        `,
        drawerTitle: css`
            display: none;
        `,
        scrim: css`
            background-color: ${color("common.black", 0.33)};
        `,
    },
};

navigationDrawerStyles.drawerSectionWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 4px;
        width: 100%;
        overflow-x: hidden;
        &.drawer-section-wrapper {
            & > .main-navigation-row {
                width: auto;
                margin: 0 8px;
            }
        }
        ${styledScrollbar()}
    `,
};

navigationDrawerStyles.mainNavigationRow = {
    css: css`
        margin: 0;
        padding: 6px 8px;
        min-height: 32px;
        width: 100%;
        ${IconWrapper}, svg {
            color: ${color("text.link")};
            height: 22px;
            width: 7px;
        }
        &:focus,
        &:hover {
            ${selectedPanelItem}
        }
    `,
    moreIconProps: {
        color: "primary",
        src: RightNav,
        size: 7,
        css: css`
            display: inline;
            &,
            svg {
                height: 22px;
            }
        `,
    },
    isCurrentCss: selectedPanelItem,
};

navigationDrawerStyles.mainNavigationRowTypography = {
    transform: "capitalize",
    color: "common.black",
    weight: fontConfig.weight.bold,
    size: 14,
    lineHeight: "22px",
};

navigationDrawerStyles.panelMenu = {
    ...sharedPanelMenuStyles,
};

navigationDrawerStyles.drawerSectionSeparator = {
    css: css`
        margin: 18px auto;
        border-top: 1px solid ${color("common.border")};
        width: calc(100% - 32px);
    `,
};

navigationDrawerStyles.accountPanelSectionWrapper = {
    css: css`
        display: flex;
        align-items: center;
        width: 100%;
    `,
};

navigationDrawerStyles.headerShipAddress = {
    shipToAddressWrapper: {
        css: css`
            margin: 0 16px 10px 16px;
            width: calc(100% - 32px);
        `,
    },
    titleClickable: {
        css: css`
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
            gap: 4px;
            && {
                align-items: start;
            }
        `,
    },
    titleIcon: {
        color: "primary.main",
    },
    changeIcon: {
        color: "primary.main",
    },
    titleTypography: {
        css: css`
            font-size: 14px;
            line-height: 17px;
        `,
    },
};
navigationDrawerStyles.middleWrapper = {
    css: css`
        margin: 0 16px;
    `,
};

navigationDrawerStyles.logoLinks = {
    color: "common.white",
    typographyProps: {
        ellipsis: true,
        transform: "capitalize",
        color: "primary",
        size: 14,
        lineHeight: "22px",
        weight: fontConfig.weight.bold,
    },
    css: css`
        padding: 6px 0;
        & > ${IconWrapper} {
            display: none;
        }
    `,
};

navigationDrawerStyles.socialLinks = {
    link: {
        typographyProps: {
            size: 14,
            lineHeight: "16px",
            weight: fontConfig.weight.bold,
        },
    },
    wrapper: {
        css: css`
            padding: 6px 16px;
        `,
    },
};

navigationDrawerStyles.menuRowIcon = {
    color: "primary",
    size: 14,
    css: css`
        opacity: 0.66;
        margin-right: 8px;
        &,
        svg {
            height: 15px;
        }
    `,
};

navigationDrawerStyles.signOutRowLink = {
    ...createLinkIconStyles(IconLogout),
};

navigationDrawerStyles.signOutRow = {
    css: css`
        padding-top: 0;
        padding-left: 17px;
    `,
};
